import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

function Select(props) {
  function onChange(event) {
    props.onChange(event);
  }

  return (
    <div>
      <label
        className={classNames({
          'widget-select-label': true,
          'widget-select-error': props.error,
        })}
      >
        {props.label}
      </label>
      <select
        {...props}
        value={props.value}
        onChange={onChange}
        className="widget-select"
      >
        {props.children}
      </select>
      {props.error && (
        <span className="widget-select-error-message">
          {props.error.message}
        </span>
      )}
      {!props.error && (
        <span className="widget-select-info info">{props.info}</span>
      )}
    </div>
  );
}

Select.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  name: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  formData: PropTypes.object ?? PropTypes.string,
  children: PropTypes.any,
  info: PropTypes.string,
  error: PropTypes.object,
};

Select.defaultProps = {
  value: '',
  onChange: () => {},
};

function Option(props) {
  return (
    <option value={props.value} selected={props.selected}>
      {props.name}
    </option>
  );
}

Option.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  selected: PropTypes.bool,
};

Select.Option = Option;

export default Select;
